export default __webpack_public_path__ + "static/side-nav-dont-4-0cb92d6ab89b328266336e2bcf7d3ab48547c0a3f600c7ceb47ff506ee6555cd.png";